<template>
	<a target="_blank" rel="noopener noreferrer" :href="buildHref">
		<slot />
	</a>
</template>

<script setup>
const { locale } = useI18n();

// The langids are defined by BookVisit
const languagesToLangId = {
	en: 2,
	no: 5,
	sv: 1,
	fallback: 2,
};

const buildHref = computed(() => {
	const url = new URL('https://online.bookvisit.com/accommodation');

	url.searchParams.set('channelid', '469c2dd2-3c58-4f0f-8a01-9ca007b77cd3');
	const langId = languagesToLangId[locale.value] || languagesToLangId.fallback;
	url.searchParams.set('langid', langId.toString());

	return url.toString();
});
</script>

<style lang="scss" scoped>
a {
	color: #fff;
	cursor: pointer;

	&:hover {
		text-decoration: none;
	}
}
</style>
